function toggleSidebar(){
  if (document.getElementById("sidebar")) {
    document.getElementById("sidebar").classList.toggle("passive");
    document.getElementById("bars").classList.toggle("fa-times");
    document.getElementById("logo").classList.toggle("d-none");
  }
}

export { toggleSidebar };
